import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef, Suspense } from 'react';

import AuthServices from '../../../class/services/AuthService';
import ModalLogin from '../modal/modal_login.js';

import {openGameModal} from './modal_game';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const LOAD_GAMES_BY_PROVIDER_ID = ({ Game, user_id, subcategory_slug, category_slug, onClose, tag_name, isLogged, AuthService, setIsLoginModalOpen}) => {
    const [games, setGames] = useState([]); 
    const [loading, setLoading] = useState(false); 
    const [page, setPage] = useState(1); 
    const [hasMore, setHasMore] = useState(true); 
    const modalBodyRef = useRef(null); 
    const {t} = useTranslation();

    const updateFavoriteGame = async (newGameId ) => {
        if (isLogged) {
            try {
                // Получаем инфу об игре
                const gameInfo = await Game.getGameInfo(newGameId);
                const gameType = gameInfo?.params?.game_info[0]?.category_slug || '';

                const user_id = await AuthService.getCustom('user_id');
                const lastGames = await Game.updateFavoriteGames(user_id, gameType, newGameId );
                
                // console.log("NUOVO GIOCO PREFERITO");

            } catch (error) {
                console.error('Failed to fetch game info or open game:', error);
            }
        } else if (!isLogged) {
            setIsLoginModalOpen(true);
            console.error(t('User_is_not_logged_in.'));
        }

        // console.log('ModalGame opened with gameId:', [newGameId, isLogged]);
    };


    const fetchGames = async (currentPage) => {
        if (loading || !hasMore) return; 
        try {
            setLoading(true);
            // console.log("SLUG " + subcategory_slug);

            if(subcategory_slug == "favorite_games") {
                const favoriteGames = await Game.getFavoriteGames(user_id, category_slug, 24, currentPage,);
                // console.log("FAVORITE");
                // console.log(favoriteGames);

                let baseGames = [];
        
                if (favoriteGames.status == "ok" && (favoriteGames.params.count > 0)) {
                    baseGames = favoriteGames.params.games.map(game => {
                        return {
                        id: game.game_id,
                        imageSrc: game.game_img,
                        providerIcon: getProviderIcon(game.provider_slug),
                        providerName: game.provider_name,
                        gameName: game.game_name,
                        favorite: game.favorite
                        };
                    });
                }

                if(favoriteGames.status == "ok"){
                    const newGames = baseGames || [];
                    setGames((prevGames) => [...prevGames, ...newGames]); 
                    setHasMore(newGames.length > 0);
                }else{
                    setHasMore(false);
                }

            } else if (category_slug === 'casino' || category_slug === 'casino-live'){
                
                if(subcategory_slug == "recent_casino" || subcategory_slug == "recent_live"){
                    const lastGames = await Game.getLastGames(user_id, category_slug, 24, currentPage,);
                    // console.log("RECENTI");
                    // console.log(lastGames);

                    let baseGames = [];
                    // const existingIds = new Set();
            
                    if (lastGames.status == "ok" && (lastGames.params.count > 0)) {
                        baseGames = lastGames.params.games.map(game => {
                            // existingIds.add(game.game_id); 
                            return {
                            id: game.game_id,
                            imageSrc: game.game_img,
                            providerIcon: getProviderIcon(game.provider_slug),
                            providerName: game.provider_name,
                            gameName: game.game_name,//name,
                            favorite: game.favorite,//name,
                            };
                        });
                    }

                    if(lastGames.status == "ok"){
                        const newGames = baseGames || [];
                        setGames((prevGames) => [...prevGames, ...newGames]); 
                        setHasMore(newGames.length > 0);
                    }else{
                        setHasMore(false);
                    }

                } else {
                    const games = await Game.getGamesBySubCategory(user_id, category_slug, subcategory_slug, 24, currentPage);
                    // console.log(games);

                    let baseGames = [];
                    // const existingIds = new Set();
            
                    if (games.status == "ok" && (games.params.count > 0)) {
                        baseGames = games.params.games.map(game => {
                            // existingIds.add(game.game_id); 
                            return {
                            id: game.id,
                            imageSrc: game.thumbnail,
                            providerIcon: getProviderIcon(game.provider_slug),
                            providerName: game.provider_name,
                            gameName: game.name,//name,
                            favorite: game.favorite,//name,
                            };
                        });
                    }

                    // 24 limit scrollable
                    // const response = await Game.getProviderGame(user_id, provider_id, 24, currentPage, '', category_id); 
                
                    if(games.status == "ok"){
                        const newGames = baseGames || [];
                        setGames((prevGames) => [...prevGames, ...newGames]); 
                        setHasMore(newGames.length > 0);
                    }else{
                        setHasMore(false);
                    }
                }

            } 
            
          
        } catch (error) {
            console.error('Error fetching games:', error);
        } finally {
            setLoading(false);
        }
    };

   
    useEffect(() => {
        fetchGames(page);
    }, [page]);


    const handleScroll = () => {
        if (!modalBodyRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = modalBodyRef.current;

        if (scrollHeight - scrollTop <= clientHeight + 50 && !loading && hasMore) {
            setPage((prevPage) => prevPage + 1); 
        }
    };

    const getProviderIcon = (providerslug) => {
        return `${cmsUrl}static-assets/providers/${providerslug}.png`;
    };


    const getSubcategoryIcon = (subcategoryslug) => {
        return `${cmsUrl}static-assets/icon-btn/${subcategoryslug}-icon.png`;
    };

    return (
        <>
            <div
                className="modal fade provider-box-modal show"
                id="ProviderModal_single"
                tabIndex="-1"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                style={{ display: 'block' }}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div
                            className="modal-body"
                            onScroll={handleScroll} 
                            ref={modalBodyRef} 
                            style={{ maxHeight: '100%', overflowY: 'auto', paddingTop: "unset" }}
                        >
                            <div className="Home_header" style={{ 
                                position: "sticky",
                                zIndex: "10",
                                top: "0px",
                                background: "#ddd",
                                margin: "unset !important",
                                padding: "15px",
                                paddingBottom: "20px !important",
                                paddingTop: "calc(var(--bs-modal-padding) + 15px)"
                            }}>
                                <a href="#" className="HomeSection_header" data-bs-dismiss="modal" aria-label="Close"  onClick={onClose} style={{ margin: "unset"}}>
                                    
                                    <div className="HomeSection_icon">
                                        <div className="arrow left"></div>
                                        <img alt={subcategory_slug} src={getSubcategoryIcon(subcategory_slug)} style={{filter:"invert(1)"}}></img>
                                        {/* <img alt={subcategory_slug} src={getSubcategoryIcon("")}></img> */}
                                    </div>
                                    
                                    <div
                                        className="HomeSection_label"
                                       
                                        style={{ cursor: 'pointer', color: "#000000" }}
                                    >  
                                        { t(`${tag_name}`) } 
                                    </div>
                                    <div className="HomeSection_right"></div>
                                </a>
                            </div>
                            <div className="body main-layout-item ColumnSection_list">
                                <div className="Home_root">
                                    <div className="Home_games">
                                        <div className="HomeSectionCasinoGames_list">
                                            {games.map((game, index) => (
                                                <div className="HomeSectionCasinoGames_game" key={index} /* onClick={() => openGameModal(game.id)} */>
                                                    <div className="CasinoGameCard_root">
                                                        <div className="CasinoGamePreview_root" onClick={() => openGameModal(game.id)}>
                                                            <div className="CasinoGamePreview_gradient"></div>
                                                            <img
                                                                className="ResponsivePicture_img CasinoGamePreview_image"
                                                                src={game.imageSrc || ''}
                                                                alt={game.gameName}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                        <div className="CasinoGameCard_info CasinoGameCard_withProvider" style={{ gridTemplateRows: "[provider-start] 16px [provider-end name-start] 1fr [name--end]", textAlign: "unset"}}>
                                                            <div className="CasinoGameCard_provider">
                                                                <img alt={game.providerName} src={game.providerIcon} className="CasinoGameCard_icon" onClick={() => openGameModal(game.id)}/>
                                                                <p className="CasinoGameCard_name" onClick={() => openGameModal(game.id)}>{game.providerName}</p>
                                                                <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                                                                    () => {
                                                                    if(isLogged){
                                                                        updateFavoriteGame(game.id);
                                                                        setGames(prev =>
                                                                        prev.map(g =>
                                                                            g.id === game.id
                                                                            ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                                                                            : g
                                                                        )
                                                                        );
                                                                    } else{
                                                                        setIsLoginModalOpen(true);
                                                                    }
                                                                    }  
                                                                }>
                                                                    <svg className="" viewBox='0 0 50 50'>
                                                                    <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                                                                        c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                                                                        C44.8,15,42.5,11,38.7,8.9z" fill={(Number(game.favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                                                                    />
                                                                    </svg>

                                                                </button>
                                                            </div>
                                                            <p className="CasinoGameCard_gameName" title={game.gameName} onClick={() => openGameModal(game.id)}>{game.gameName}</p>
                                                            {/* <p className="CasinoGameCard_gameName">{game.name}</p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            {loading && (
                                                <div className="content-loader-games">
                                                    {t('Loading games')}...
                                                    <div className="loader-games"></div>
                                                </div>
                                            )}
                                            {!hasMore && <p>{t('No_more_games_to_load')}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
        </>
    );
};

export default LOAD_GAMES_BY_PROVIDER_ID;
